import { jssToCSS } from "./jssToCSS.js";
const jssEntryToCSS = (styleObj) => jssToCSS({
  styleObj: {
    [`.${styleObj.className}`]: styleObj
  }
});
export {
  jssEntryToCSS
};
//# sourceMappingURL=jssEntryToCSS.js.map
